import request from './request';
/**
 *  获取标签列表
 */
export function getLabelList(params) {
    return request('/tags-type/list', {
        method: 'POST',
        params,
    });
}
/**
 *  新建标签分类
 */
export function addLabel(params) {
    return request('/tags-type/', {
        method: 'POST',
        params,
    });
}
/**
 *  修改标签分类
 */
export function editLabel(id, params) {
    return request(`/tags-type/${id}`, {
        method: 'PATCH',
        params,
    });
}
/**
 *  删除标签分类
 */
export function deleteLabel(id) {
    return request(`/tags-type/${id}`, {
        method: 'DELETE',
    });
}
/**
 *  标签分类详情
 */
export function getLabelDetail(id) {
    return request(`/tags-type/${id}`, {
        method: 'GEt',
    });
}
/**
 *  获取历史记录
 */
export function getLabelTypeHistory(id, params) {
    return request(`/tags-type/record/${id}`, {
        method: 'POST',
        params,
    });
}
